import { useEffect, useState } from 'react'
import { fetchVideoTranscriptVttUrl } from 'src/v3/classroom-v2/utils/api'

// Course v2's transcript endpoint is scoped by courseID (see Course v2's
// access model — there's no Class entity to authorize against, so access
// is resolved via the course directly), unlike v1's videoID-only endpoint
// behind src/v3/utilities/hooks/use-vtt-subtitles.ts. A missing transcript
// isn't an error state — plenty of videos simply don't have one yet.
//
// isSettled distinguishes "still checking" from "checked, no transcript" —
// the caller needs this to hold off mounting <mux-player> (and its <track>
// child) until the check resolves either way, rather than mounting
// immediately with no track and adding one once the URL arrives, which
// <mux-player> doesn't reliably pick up after its initial mount.
export let useVideoTranscriptVtt = (
  courseID: string,
  videoID: string,
): { vttUrl: string | null; isSettled: boolean } => {
  let [vttUrl, setVttUrl] = useState<string | null>(null)
  let [isSettled, setIsSettled] = useState(false)

  useEffect(() => {
    let isStale = false
    setVttUrl(null)
    setIsSettled(false)
    fetchVideoTranscriptVttUrl(courseID, videoID)
      .then((url) => {
        if (!isStale) setVttUrl(url)
      })
      .catch(() => {
        if (!isStale) setVttUrl(null)
      })
      .finally(() => {
        if (!isStale) setIsSettled(true)
      })
    return () => {
      // eslint-disable-next-line fp/no-mutation
      isStale = true
    }
  }, [courseID, videoID])

  return { vttUrl, isSettled }
}
